export default {
  privacypolicy: {
    'a': '本協議由蓋德科技股份有限公司（以下簡稱為“蓋德”）與您（以下簡稱為“用戶”）訂立，保證您對本應用各項服務的使用權利及隱私，請您認真閱讀，一經註冊或以其他方式使用我們的產品和服務，您將被視為確認接受本條款並同意成為具有約束力的本合同的一方，若您不同意任意條款請停止使用本應用。蓋德可能就本應用提供的某項特定服務於您簽訂單獨的服務條款，您在遵守本協議的同時還需要遵守與特定服務相關的特定服務條款。就相關事宜，雙方達成如下協議：',
    'b': '使用前提',
    'c': '1. 用戶必須同意本協議條款後才能使用。',
    'd': '2. 若您在18周歲以下，您必須確保在父母或監護人的監護下使用。',
    'e': ' 若您在18周歲以下，您必須確保在父母或監護人的監護下使用。 ',
    'f': '3. 您同意蓋德在法律允許範圍內有權獨自決定關閉您的帳戶、清除帳戶內資訊。',
    'g': '4. 您必須能夠自行通過有法律資格的第三方對您提供互聯網接入服務，並自行承擔以下內容：',
    'h': '1) 自行配備上網設備，包括個人電腦，數據機及其他必要的設備裝置；',
    'i': '2) 自行承擔上網費用，如網路接入費用、電話費用、流量費用等',
    'j': '責任限制及不承諾擔保',
    'k': '1. 您同意在自己承擔風險的情況下，按本應用的現狀使用相關產品及服務。蓋德特此申明對本應用之使用不提供任何保證（包含但不限於商業擔保和特殊目的的適用性擔保），亦不對您因服務暫停或終止而遭受的任何直接或間接損失承擔責任。蓋德不保證您一定能夠獲得服務，蓋德有權隨時暫停或終止全部或部分服務。',
    'l': '2. 本應用所有資訊都不能作為診斷、用藥及醫療的依據。您同意就基於經閱讀本應用發佈的資訊做出的任何行為及後果（包括蓋德可能遭受的任何損失或損害）承擔責任，蓋德不對您或任何第三方承擔責任。',
    'm': '3. 本應用中向您提供的任何回饋、意見或建議僅是依據您描述提供的建議性內容，不能作為診斷、用藥及醫療的依據，是否採用是您的個人行為，蓋德不承擔其言行導致後果承擔任何責任',
    'n': '4. 您理解本應用中可能包含由第三方提供的服務，蓋德只是為了您的便利而提供功能模組。您使用第三方提供的服務，需與第三方另行達成服務協議，支付相應的費用並承擔可能的風險。蓋德對第三方所提供的服務不承擔任何形式的擔保。',
    'o': '非排他性許可',
    'p': '1. 本應用（包括但不限於本應用中所含的任何圖像、照片、動畫、文字和附加程式、修正程式、更新版本和升級版本）的一切所有權和知識產權，均由蓋德擁有。',
    'q': '2. 蓋德僅可撤銷、非排他地授權您，依照本協議條款和條件，(a)為在您的網站或第三方網站上使用本應用服務的需要而安裝、複製和使用本應用； (b) 在遵守所有的適用法律和法規的前提下，通過遠程訪問、流覽和下載您的本應用的數據。 ',
    'r': '隱私權保護',
    's': '1. 蓋德尊重並保護您的隱私權，您註冊的帳戶名、電子郵件地址、證件資訊、您提交的健康資訊等個人資訊，非經您的許可，或根據相關法律、法規的強制性規定或您的允許，以及蓋德為維護改進軟體服務為目的等，不會主動地洩露給第三方。',
    't': '2. 本應用還可能收集您的IP地址、移動設備類型、流覽器性質、操作系統類型等非個人資訊以便優化您在本應用的用戶體驗',
    'u': '3. 您在使用該軟體的過程中應當遵守法律法規中關於隱私權的保護，不得自行（且不得允許任何第三方）使用本應用追蹤或收集互聯網用戶的個人身份資訊，也不得自行（且不得允許任何第三方）將從您的網站（或該第三方的網站）收集的任何數據與從任何來源獲得的任何個人身份資訊相聯系。',
    'v': '4. 資訊披露 在如下情況下，本應用將依據您的個人意願或法律的規定全部或部分的披露您的個人資訊：',
    'w': '1) 經您事先同意，向第三方披露；',
    'x': '2) 為提供您所要求的產品和服務，而必須和第三方分享您的個人資訊；',
    'y': '3) 根據法律的有關規定，或者行政或司法機構的要求，向第三方或者行政、司法機構披露；',
    'z': '4) 如您出現違反有關法律、法規或者本應用服務協議或相關規則的情況，需要向第三方披露；',
    'aa': '5) 如您是適格的知識產權投訴人並已提起投訴，應被投訴人要求，向被投訴人披露，以便雙方處理可能的權利糾紛；',
    'bb': '6) 其他本應用根據法律、法規或者網站政策認為合適的披露。',
    'cc': '終止',
    'dd': '1. 若您違反本協議的任何條款，蓋德有權立即終止本協議。同時蓋德有權在沒有任何理由和/或通知的情形下隨時終止或暫停對您的授權。授權一旦取消，您使用本應用的權利即刻終止。此種情況下您必須停止使用本應用，銷毀本應用及其各部分的所有副本，並在終止後三個工作日內以書面形式向蓋德做出銷毀證明，否則，用戶將承擔相應的未經授權使用他人軟體的法律責任。',
    'ee': '2. 若因您違反本協議導致協議終止：',
    'ff': '1) 您無權得到任何損失補償；',
    'gg': '2) 您將無權獲得您的一切歷史數據。 ',
    'hh': '不可抗力',
    'ii': '除法律規定不可抗力情形外，下列情況亦屬於不可抗力：',
    'jj': '1. 任何公共的互聯網骨幹網、網路或伺服器停運。',
    'kk': '2. 您的設備、系統或當地連接服務發生故障。',
    'll': '3. 已經預定的維修。',
    'mm': '4. 您的伺服器所在地區的互聯網服務中斷。 ',
    'nn': '5. 駭客攻擊。 ',
    'oo': '6. 公司業務調整或其他不能預見的情況。',
    'pp': '條款和政策的修改及關注義務',
    'qq': '本應用新推出的產品、服務，新增加的功能均受到本協議的規範。蓋德有權修改、變更本協議條款和服務政策，您有責任定期查看。如您不接受變更、修改後的協議條款和服務政策的，應立即停止使用本軟體，並按照終止條款的規定銷毀已下載使用的軟體產品。若您接受變更後的條款或繼續使用本應用的服務，表明您接受變更後的協議約束。 ',
    'rr': '法律適用及管轄',
    'ss': '本協議的訂立、執行和解釋均適用中華民國地區適用之法律。因本協議或使用本軟體產品所引起的爭議由當地人民法院或其上級法院管轄。蓋德對本協議內容擁有合法範圍內最終解釋權',
    'tt': '感謝您使用本應用，我們將致力於為您提供更貼心的服務！'
  }
}
